export default {
  completionAvg75to100: {
    page: 1,
    size: 5
  },
  completionAvg50to74: {
    page: 1,
    size: 5
  },
  completionAvg25to49: {
    page: 1,
    size: 5
  },
  completionAvg0to24: {
    page: 1,
    size: 5
  }
};
